jQuery(document).ready(function ($) {
	function addCountryTransitions() {
		$('#billing_country, #shipping_country').each(function () {
			if ($(this).hasClass('select2-hidden-accessible')) {
				$(this).off(
					'select2:open.customTransition select2:close.customTransition'
				);

				$(this).on('select2:open.customTransition', function () {
					$('.select2-dropdown').addClass('country-opening');
				});

				$(this).on('select2:close.customTransition', function () {
					$('.select2-dropdown').addClass('country-closing');
					setTimeout(() => {
						$('.select2-dropdown').removeClass('country-opening');
						$('.select2-dropdown').removeClass('country-closing');
					}, 300);
				});
			}
		});
	}

	addCountryTransitions();

	$(document.body).on('updated_checkout', function () {
		setTimeout(addCountryTransitions, 100);
	});
});
